import React, { useContext, useEffect, useState } from 'react'
import UserContext from '../../../services/context/userContext';
import { getClients } from '../../../services/firebase/firestore/getData';
import Loading from '../../_default/Loading';
import SearchPage from '../../_default/SearchPage'
import ActiveClientsList from '../ActiveClientsList';
import "./ActiveClients.scss"
import Select from 'react-select';
import ExerciseListItem from '../../_exercises/ExerciseList/ExerciseListItem';
import ExerciseList from '../../_exercises/ExerciseList';
import DropDown from '../../_default/DropDown';
function ActiveClients() {
    const user = useContext(UserContext);
    let [clients,setClients]=useState([])
    let [loading,setLoading]=useState(true)
    let [searchClient,setSearchClient]=useState("")
    const [searchValue, setSearchValue] = useState("");
    let [desc, SetDesc] = useState(false);
    const filters = ["Sort by name", "Sort by date"];
  const [filter, setFilter] = useState("Sort by name");
  const filterTypes = ["Ascending", "Descending"];
  const [filterType, setFilterType] = useState("Ascending");
  let url = new URL(window.location.href);
  const [filterName, setFilterName] = useState(false);
  const [client_name, setCLientName] = useState(false);
  const [clientCount, setClientCount] = useState(false);
  function sortClient(a, b) {
    // debugger
    // if (a.first_name + " " + a.last_name < b.first_name + " " + b.last_name) {
    //     return -1;
    // }
    // if (a.first_name + " " + a.last_name > b.first_name + " " + b.last_name) {
    //     return 1;
    // }
    // return 0;

    const name1 = a.first_name + " " + a.last_name;
    const name2 = b.first_name + " " + b.last_name;

    let comparison = 0;

    if (name1 > name2) {
      comparison = 1;
    }
    if (name1 < name2) {
      comparison = -1;
    }
    return comparison;
  }
  function sortClientDesc(a, b) {
    const name1 = a.first_name + " " + a.last_name;
    const name2 = b.first_name + " " + b.last_name;

    let comparison = 0;

    if (name1 < name2) {
      comparison = 1;
    }
    if (name1 > name2) {
      comparison = -1;
    }
    return comparison;
  }
  // useEffect(() => {
  //   debugger
   
  //   if (searchValue) {
  //     const results = clients.filter((client) => {
  //       if (searchValue === "") return clients;
  //       return (client.first_name + " " + client.last_name)
  //         .toLowerCase()
  //         .includes(searchValue.toLowerCase());
  //     });
  //     setClients(results);
  //     // console.log("filter client info", results, clientInfo)
  //   } else if (filter === "Sort by date" && desc) {
  //     getClients(user.id, (result) => {
  //       if (result) {
  //         setLoading(false);

  //         let res = result.sort(function (a, b) {
  //           // Turn your strings into dates, and then subtract them
  //           // to get a value that is either negative, positive, or zero.
  //           //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
  //           return (
  //             b.date_of_birth?.toDate().getFullYear() -
  //             a.date_of_birth?.toDate().getFullYear()
  //           );
  //           // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
  //         });
  //         console.log("result", result[0].date_of_birth.toDate().getFullYear());
  //         setClients(res);
  //         let clientNames = [];
  //         let clients = [];
  //         result &&
  //           result.forEach((element) => {
  //             clientNames.push(element.first_name + " " + element.last_name);
  //             clients.push({
  //               name: element.first_name + " " + element.last_name,
  //               id: element.id,
  //             });
  //           });
  //         setFilterName(clientNames);
  //         setCLientName(result[0].first_name + " " + result[0].last_name);
  //         setClients(clients);
  //       }
  //     });
  //   } else if (filter == "Sort by date") {
  //     getClients(user.id, (result) => {
  //       if (result) {
  //         setLoading(false);

  //         let res = result.sort(function (a, b) {
  //           // Turn your strings into dates, and then subtract them
  //           // to get a value that is either negative, positive, or zero.
  //           //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
  //           return (
  //             a.date_of_birth?.toDate().getFullYear() -
  //             b.date_of_birth?.toDate().getFullYear()
  //           );
  //           // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
  //         });
  //         console.log("result", result[0].date_of_birth.toDate().getFullYear());
  //         setClients(res);
  //         let clientNames = [];
  //         let clients = [];
  //         result &&
  //           result.forEach((element) => {
  //             clientNames.push(element.first_name + " " + element.last_name);
  //             clients.push({
  //               name: element.first_name + " " + element.last_name,
  //               id: element.id,
  //             });
  //           });
  //         setFilterName(clientNames);
  //         setCLientName(result[0].first_name + " " + result[0].last_name);
  //         setClients(clients);
  //       }
  //     });
  //   } else if (filter) {
  //     // debugger
  //     console.log("filters ",filter)
  //     // debugger
  //     if (desc) {
  //       getClients(user.id, (result) => {
  //         setClientCount(result.length);
  //       });

  //       getClients(user.id, (result) => {
  //         if (result) {
  //           console.log("result dubugginng",result)
  //           setLoading(false);
  //           result = result.sort(sortClient);

  //           setClients(result);
  //           let clientNames = [];
  //           let clients = [];
  //           result &&
  //             result.forEach((element) => {
  //               clientNames.push(element.first_name + " " + element.last_name);
  //               clients.push({
  //                 name: element.first_name + " " + element.last_name,
  //                 id: element.id,
  //               });
  //             });
  //             setFilterName(clientNames);
  //             setCLientName(result[0].first_name + " " + result[0].last_name);
  //           setClients(clients);
  //         }
  //       });
  //     } else {
  //       getClients(user.id, (result) => {
  //         setClientCount(result.length);
  //       });
  //       console.log("filters else ")
  //       // debugger
  //       getClients(user.id, (result) => {
  //         if (result) {

  //           console.log("clients ",result)
  //           setLoading(false);
  //           // result = result.sort(sosrtClientDesc);

  //           setClients(result);
  //           let clientNames = [];
  //           let clients = [];
  //           result &&
  //             result.forEach((element) => {
  //               clientNames.push(element.first_name + " " + element.last_name);
  //               clients.push({
  //                 name: element.first_name + " " + element.last_name,
  //                 id: element.id,
  //               });
  //             });
  //           setFilterName(clientNames);
  //           setCLientName(result[0].first_name + " " + result[0].last_name);
  //           setClients(clients);
  //         }
  //       });
  //     }
  //   }
  //   else{
  //     getClients(user.id,res=>{
  //       setClients(res)
  //     })
  //   }
    
  // }, [searchValue, filter, desc,loading]);


    useEffect(()=>{
      // localStorage.removeItem("tabIndex")
       if (searchValue) {
      const results = clients.filter((client) => {
        if (searchValue === "") return clients;
        return (client.first_name + " " + client.last_name)
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setClients(results);
      // console.log("filter client info", results, clientInfo)
    }
    else if(filter=="Sort by name"&&desc){
      
        getClients(user.id,res=>{
          console.log("clients",res)

          if(res){
            setLoading(false)
            let filt=res.sort(sortClientDesc)
            setClients(filt)
          }
        })
    }
    else if(filter=="Sort by date"){
      console.log("sort by date")
      if(desc){
        getClients(user.id, (result) => {
          if (result) {
            setLoading(false);
  
            let res = result.sort(function (a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
              return (
                b.date_of_birth?.toDate().getFullYear()-
                a.date_of_birth?.toDate().getFullYear() 
              );
              // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
            });
            console.log("result",res);
             setClients(res);
            let clientNames = [];
            let clients = [];
            // result &&
            //   result.forEach((element) => {
            //     clientNames.push(element.first_name + " " + element.last_name);
            //     clients.push({
            //       name: element.first_name + " " + element.last_name,
            //       id: element.id,
            //     });
            //   });
            // setFilterName(clientNames);
            // setCLientName(result[0].first_name + " " + result[0].last_name);
            // setClients(clients);
          }
        });
      }else{
        getClients(user.id, (result) => {
          if (result) {
            setLoading(false);
  
            let res = result.sort(function (a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
              return (
                a.date_of_birth?.toDate().getFullYear() -
                b.date_of_birth?.toDate().getFullYear()
              );
              // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
            });
            console.log("result",res);
             setClients(res);
            let clientNames = [];
            let clients = [];
            // result &&
            //   result.forEach((element) => {
            //     clientNames.push(element.first_name + " " + element.last_name);
            //     clients.push({
            //       name: element.first_name + " " + element.last_name,
            //       id: element.id,
            //     });
            //   });
            // setFilterName(clientNames);
            // setCLientName(result[0].first_name + " " + result[0].last_name);
            // setClients(clients);
          }
        });
      }
      
    }
    // else if(filter=="Sort by date"&&desc){
    //   console.log("sort by date decs")
    //   getClients(user.id, (result) => {
    //           if (result) {
    //             setLoading(false);
      
    //             let res = result.sort(function (a, b) {
    //               // Turn your strings into dates, and then subtract them
    //               // to get a value that is either negative, positive, or zero.
    //               //    return a.date_of_birth?.toDate().getDate() / a.date_of_birth?.toDate().getMonth() + 1 / a.date_of_birth?.toDate().getFullYear() - b.date_of_birth?.toDate().getDate() / b.date_of_birth?.toDate().getMonth() + 1 / b.date_of_birth?.toDate().getFullYear();
    //               return (
    //                 b.date_of_birth?.toDate().getFullYear()-
    //                 a.date_of_birth?.toDate().getFullYear() 
    //               );
    //               // return moment((a.date_of_birth).format('YYYYMMDD'))-moment((b.date_of_birth).format('YYYYMMDD'))
    //             });
    //             console.log("result", result[0].date_of_birth.toDate().getFullYear());
    //             setClients(res);
    //             let clientNames = [];
    //             let clients = [];
    //             // result &&
    //             //   result.forEach((element) => {
    //             //     clientNames.push(element.first_name + " " + element.last_name);
    //             //     clients.push({
    //             //       name: element.first_name + " " + element.last_name,
    //             //       id: element.id,
    //             //     });
    //             //   });
    //             // setFilterName(clientNames);
    //             // setCLientName(result[0].first_name + " " + result[0].last_name);
    //             // setClients(clients);
    //           }
    //         });
    // }
    else{
      debugger
        getClients(user.id,res=>{
        console.log("clients",res)
        if(res){
          setLoading(false)
          // setClients(res.sortClient())
          let filt=res.sort(sortClient)
         
          setClients(filt)
        }
       
    })

    
    
    }
        
    },[searchValue,desc,filter,loading])
    function setFilterParam(e) {
      let search_params = url.searchParams;
      search_params.set('filter', e);
      url.search = search_params.toString();
      let new_url = url.toString();
      window.history.replaceState(null, null, new_url);
    }
  
    function setFilterTypeParam(e) {
      let search_params = url.searchParams;
      search_params.set('filterType', e);
      url.search = search_params.toString();
      let new_url = url.toString();
      window.history.replaceState(null, null, new_url);
    }
    const handleSortClient = (e) => {
      // console.log("sort client handle", e)
      setFilter(e);
    };

  return (
    <div className='c-page-wrapper c-page-dashboard c-page-exercises' style={{padding:"unset"}}>
    <div className='c-page-wrapper--exercises'>
    <div className="c-page-main--exercises">
          {/* <div className="c-exercise-finder">
            <SearchPage placeholder="Search excercise"   value={searchClient} onChange={(e)=>{setSearchClient(e.target.value)}} /> */}
            {/* <Select options={
              clients.map((data)=>({
                value: data.userID,
                label: data.first_name+" "+data.last_name ,
  
              }))
            } 
            onChange={(e)=>{setSearchClient(e.label)}} 
            placeholder="Find your active client"
            /> */}
            {/* <div className="c-dropdown-holder">
              <DropDown options={filters} value={filter} onChange={(e) => {setFilter(e); setFilterParam(e)}} />
              <DropDown options={filterTypes} value={filterType} onChange={(e) => {setFilterType(e); setFilterTypeParam(e)}} />
            </div> */}
          
            {/* </div> */}
            <div
              className="c-exercise-finder"
              style={{
                marginTop: "30px",
                marginLeft: "15px",
              }}
            >
              <SearchPage
                placeholder="Search client"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
              <div className="c-dropdown-holder">
                <DropDown
                  options={filters}
                  value={filter}
                  onChange={handleSortClient}
                />
                <DropDown
                  options={filterTypes}
                  value={filterType}
                  onChange={() => {
                    SetDesc(!desc);
                    setFilterType(
                      filterType == "Ascending" ? "Descending" : "Ascending"
                    );
                  }}
                />
              </div>
            </div>
            <div style={{marginTop:"5%"}}>
              {
                loading?
                <div style={{marginTop:"5%"}}>
                    <Loading />
                </div>:

            // <ActiveClientsList clients={clients} />
            // <ExerciseListItem clients={clients} activeClient={true} />
            <ExerciseList loading={loading} setLoading={setLoading} clients={clients} activeClient={true} />
              // console.log("client list",clients)
              }
            </div>
                
          {/* <div className="c-side-options">
            <ul>
              {categories[from] &&
                _initial_categories.map((item, idx) => (
                  <li key={idx}>
                    <div className="checkbox" onClick={() => {handleCheck(item); setParamsCategories(item) }}>
                      <Icon icon={checked.includes(item) ? "checked" : "unchecked"} size={20} height={20} color={checked.includes(item) ? '#00B9A5' : "#979797"} />
                    </div>
                    <p>
                      {item} ({ categories[from].filter((e) => e.category === item)[0].count })
                    </p>
                  </li>
                ))}
              
            
            </ul>
          </div>

          
          {loading ? 
            <div className="c-list-loader">
              <Spinner  size={50}/>
            </div>
           : (
            <ExerciseList history={props.history} from={from} exercises={exercises[from]} removeExercise={(e) => setShowPopup({ type: "exercise", ...e })} />
          )} */}
        </div>

    </div>
    </div>
  )
}

export default ActiveClients